export enum SubscriptionState {
    NONE = 0,
    VALID = 1,
    EXPIRED = 2,
    TRIAL = 3,
    TRIAL_ENDED = 4
}
